<script>
// eslint-disable-next-line
import polylineDecorator from 'leaflet-polylinedecorator';
export default {
	name: 'LeafletLine',
	inheritAttrs: false,
	props: {
		points: {
			type: Array,
			default: () => ([]),
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		addArrows: {
			type: Boolean
		}
	},
	inject: {
		leaflet: 'leaflet',
		state: 'state',
		getLayer: { default: null }
	},
	data() {
		return {
			line: null,
			rendered: false,
			decorator: null
		};
	},
	watch: {
		color() {
			this.rerender();
		},
		points() {
			this.rerender();
		}
	},
	async created() {
		this.createLine();
	},
	beforeDestroy() {
		if (this.state.map) {
			let layer = this.getLayer ? this.getLayer() : undefined;
			if (this.line) {
				if (layer && layer.removeLayer) layer.removeLayer(this.line);
				else this.line.remove();
			}
			if (this.decorator) {
				if (layer && layer.removeLayer) layer.removeLayer(this.decorator);
				else this.decorator.remove();
			}

			this.rendered = false;
		}
	},
	methods: {
		validatePoints() {
			for (let point of this.points) {
				if (!this.validatePoint(point)) return false;
			}
			return true;
		},
		validatePoint(point) {
			if (!point || point.latitude === undefined || point.longitude === undefined) {
				return false;
			} else if (isNaN(point.latitude) || isNaN(point.longitude)) {
				return false;
			}

			return true;
		},
		createLine() {
			if (!this.validatePoints()) return;

			this.line = this.leaflet.polyline(
				[this.points.map(x => [ x.latitude, x.longitude ])], {
					...this.$attrs,
					color: 'currentColor',
					className: `leaflet-additional-line-style ${this.color}`,
					interactive: false,
					renderer: this.leaflet.svg()
				});
			if (this.addArrows) {
				this.decorator = this.leaflet.polylineDecorator(this.line, {
					patterns: [
						{
							offset: 0,
							repeat: 50,
							symbol: this.leaflet.Symbol.arrowHead({
								pixelSize: 12,
								polygon: true,
								pathOptions: { stroke: true,
									renderer: this.leaflet.svg(),
									weight: 1,
									lineJoin: 'miter',
									fill: true,
									fillColor: 'currentColor',
									fillOpacity: 1,
									color: 'currentColor',
									className: `leaflet-additional-line-style ${this.color}` }
							})
						}
					]
				});
			}

		},
		rerender() {
			if (this.line) this.line.remove();
			if (this.decorator) this.decorator.remove();
			this.line = null;
			this.createLine();
			this.rendered = false;
		},
	},
	render() {
		if (this.state.map && this.line && !this.rendered) {
			this.line.remove();
			if (this.decorator) this.decorator.remove();
			let layer = this.getLayer ? this.getLayer() : undefined;
			if (layer && layer.addLayer) {
				layer.addLayer(this.line);
				if (this.decorator) layer.addLayer(this.decorator);
			} else {
				this.line.addTo(this.state.map);
				if (this.decorator) this.decorator.addTo(this.state.map);
			}
			this.rendered = true;
		}
		return null;
	}
};
</script>

<style lang="scss">
@import '~@/components/evergreen/scss/colors';

.leaflet-additional-line-style {
	cursor: grab !important;

	@each $key, $value in $palette {
		&.#{$key} {
			color: get-color($value, 'base');
		}
	}
}
.leaflet-additional-line-style:hover {
	cursor: grab !important;
}

</style>
